import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { apiUrl } from "../../../Utility.js";
import _ from "lodash";
import styled from "styled-components";
import * as Actions from "../../../Actions/Actions";
import windowSize from "react-window-size";
import 'video.js/dist/video-js.css';
import Back from "../../../../assets/arrow_back.png";
import VideoPlayer from "../VideoPlayer";
import videojs from 'video.js'


const Body = styled.div`
  position: relative;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100vh;
  width: 100vw;
  display: flex;al
  justify-content: ${props => (props.ratio <= 1.78 ? "center" : "flex-start")};
  align-items: center;
  flex-direction: column;
  background-color: rgba(1, 1, 1);
`;

// const PlayerContainer = styled.div`
//   position: relative;
//   height: ${props => props.height};
//   width: ${props => props.width};
//   > iframe {
//     position: absolute;
//     top: 0;
//     left: 0;
//     bottom: 0;
//     right: 0;
//     width: 100%;
//     height: 100%;
//   }
// `;

const Exit = styled.div`
  color: white;
  margin-left: 3vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 2vw;
  &:hover {
    cursor: pointer;
  }
`;
const Arrow = styled.img`
  width: 3vw;
`;
const Title = styled.div.attrs({
  children: props => props.title
})`
  margin-right: 3.5vw;
  color: white;
  font-size: 2vw;
  font-weight: 600;
`;
const TopRow = styled.div`
  transition: all 0.7s;
  height: 10vh;
  width: 100vw;
  margin-bottom: -10vh;
  opacity: ${props => props.opacity};
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

class Show extends Component {
  constructor() {
    super();
    this.state = {
      videoId: "285108983",
      opacity: "1",
      isHovered: false
    };
    this.updateProgress = this.updateProgress.bind(this);
    this.nextVideo = this.nextVideo.bind(this);
    this.fadeOutInterval = setInterval(this.fadeOut, 5000);
    this.progressInterval = setInterval(this.updateProgress, 5000);
  }
  render() {
    const { classes, windowWidth, windowHeight, queue } = this.props;
    let width = "100%";
    let height = "100vh";
    let ratio = windowWidth / windowHeight;
    if (ratio <= 1.78 && this.state.progress > 1) {
      width = "100vw";
      height = "100%";
    }
    
    const vidStyle = {
      height: '100vh',
      width: '100vw'
    }
    return (
      <Body ratio={ratio} id="nocursor" onMouseMove={this.fadeIn}>
        <TopRow opacity={this.state.opacity}>
          <Exit onClick={this.props.match.params.playCount !== "0" ?  () => {this.props.history.push('/')} : this.props.history.goBack}>
            <Arrow src={Back} />
            Exit
          </Exit>
          <Title
            title={this.props.queue.content[this.props.queue.index].caption}
          />
        </TopRow>
        <VideoPlayer
          style = {vidStyle}
        />
      </Body>
    );
  }

  fadeOut = () => {
    if (this.fadeOutInterval !== null && this.state.isHovered === false) {
      this.setState({ opacity: "0" });
      document.getElementById("nocursor").style.cursor = "none";
    }
  };

  fadeIn = () => {
    this.setState({ opacity: "1" });
    document.getElementById("nocursor").style.cursor = "default";
  };

  async nextVideo() {
    const { queue, dispatch, match } = this.props;
    console.log("PLAY COUNT");
    console.log(match.params.playCount);
    if (match.params.playCount < 3) {
      await dispatch(
        Actions.playNextShowInQueue(this.props.history, match.params.playCount)
      );
      this.player.src({
        type: 'application/x-mpegURL',
        src: this.props.queue.content[this.props.queue.index].h264URL
      });
    } else {
      this.props.history.push('/');
    }
  }

  updateProgress = () => {    
    let currentTime;
    currentTime = this.player.currentTime();
    if (currentTime.toFixed(0) >= 1680) {
      currentTime = 0;
    }
    const { queue } = this.props;
    const req = new Request(
      `https://${apiUrl}/api/v1/user_progress?video_id=${
        queue.content[queue.index].id
      }&progress_in_seconds=${currentTime.toFixed(0)}&token=${
        this.props.user.token
      }`,
      {
        method: "POST"
      }
    );
    fetch(req).then(response => {});
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.componentCleanup);
    let video_source = this.props.queue.content[this.props.queue.index].h264URL;
    const videoJsOptions = {
      autoplay: true,
      controls: true,
      sources: [{
        src: video_source,
        type: 'application/x-mpegURL'
      }],
    }
    this.player = videojs("video-player-id", videoJsOptions, function onPlayerReady() {
      //console.log('onPlayerReady', this)
    });
    if (this.props.queue.content[this.props.queue.index].progress !== 0) {
      this.player.currentTime(this.props.queue.content[this.props.queue.index].progress);
    }
    this.player.on('ended', this.nextVideo);

    // if (this.props.match.params.playCount !== "0") {
    //   setTimeout(() => {
    //     player.play();
    //   }, 1000);
    //   return
    // }
    // if (this.props.queue.content[this.props.queue.index].progress >= 1740) {        
    //   setTimeout(() => {
    //     player.play();
    //   }, 1000);
    //   return
    // }
    
    // setTimeout(() => {
    //   player.play();
    // }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.progressInterval);
    clearInterval(this.fadeOutInterval);
    if (this.player) {
      this.player.dispose()
    }
  }

  componentCleanup = () => {
    clearInterval(this.progressInterval);
    clearInterval(this.fadeOutInterval);
  };
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    libraryState: state.mainState.libraryState,
    library: state.mainState.library,
    queue: state.mainState.queue,
    showsPlayedCount: state.mainState.showsPlayedCount,
    autoPlay: state.mainState.autoPlay,
    volume: state.mainState.volumeState
  };
};

export default (withRouter(connect(mapStateToProps)(windowSize(Show))));



// WEBPACK FOOTER //
// ./src/js/Components/Home/Shows/Show.jsx